import React from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import VerifiedIcon from "@mui/icons-material/Verified";

import { Routes_path } from "../../routerApp";
import certPdf from "../../../../static/images/common/certificato-iso-9001.pdf";

const logoBigliaBN = require("../../../../static/images/logo/logo-Scarso_nuovo_solo.png");

const linkSx = {
	color: "rgba(255,255,255,0.78)",
	textDecoration: "none",
	display: "inline-block",
	py: 0.5,
	transition: "color 150ms ease",
	"&:hover": { color: "#ffd42d" },
};

const ColumnTitle = ({ children }: { children: React.ReactNode }) => (
	<Typography
		variant="overline"
		sx={{
			color: "#ffd42d",
			letterSpacing: "0.18em",
			fontWeight: 500,
			mb: 2,
			display: "block",
		}}
	>
		{children}
	</Typography>
);

export default function Footer() {
	return (
		<Box
			component="footer"
			sx={{
				bgcolor: "#1a1a1a",
				color: "rgba(255,255,255,0.78)",
				pt: { xs: 6, md: 8 },
				pb: 3,
				mt: "auto",
			}}
		>
			<Container maxWidth="lg">
				<Grid container spacing={{ xs: 5, md: 6 }}>
					<Grid size={{ xs: 12, md: 4 }}>
						<Stack direction="row" spacing={2} sx={{ alignItems: "center", mb: 2 }}>
							<Box
								component="img"
								src={logoBigliaBN}
								alt="Scarso Romualdo e Figli"
								sx={{ width: 48, filter: "brightness(0) invert(1)" }}
							/>
							<Typography variant="h6" sx={{ color: "#fff" }}>
								Scarso Romualdo e Figli
							</Typography>
						</Stack>
						<Typography variant="body2" sx={{ color: "rgba(255,255,255,0.6)" }}>
							Macellazione Avicola
						</Typography>
					</Grid>

					<Grid size={{ xs: 12, sm: 6, md: 4 }}>
						<ColumnTitle>Contatti</ColumnTitle>
						<Stack spacing={1.5}>
							<Stack direction="row" spacing={1.5} sx={{ alignItems: "flex-start" }}>
								<LocationOnIcon fontSize="small" sx={{ mt: 0.3, color: "#ffd42d" }} />
								<Typography variant="body2">
									Via Garibaldi, 43
									<br />
									Ponte San Nicolò (Padova)
								</Typography>
							</Stack>
							<Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
								<LocalPhoneIcon fontSize="small" sx={{ color: "#ffd42d" }} />
								<Box
									component="a"
									href="tel:+390498961477"
									sx={{ ...linkSx, py: 0 }}
								>
									<Typography variant="body2">+39 049 896 1477</Typography>
								</Box>
							</Stack>
							<Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
								<AlternateEmailIcon fontSize="small" sx={{ color: "#ffd42d" }} />
								<Box
									component="a"
									href="mailto:amministrazione@macelloscarso.it"
									sx={{ ...linkSx, py: 0 }}
								>
									<Typography variant="body2">
										amministrazione@macelloscarso.it
									</Typography>
								</Box>
							</Stack>
						</Stack>
					</Grid>

					<Grid size={{ xs: 12, sm: 6, md: 4 }}>
						<ColumnTitle>Navigazione</ColumnTitle>
						<Stack spacing={0.25} sx={{ mb: 4 }}>
							<Box component={Link} to={Routes_path.HOME} sx={linkSx}>
								<Typography variant="body2">Home</Typography>
							</Box>
							<Box component={Link} to={Routes_path.CONTATTI} sx={linkSx}>
								<Typography variant="body2">Contatti</Typography>
							</Box>
							<Box component={Link} to={Routes_path.PRIVACY} sx={linkSx}>
								<Typography variant="body2">Privacy Policy</Typography>
							</Box>
							<Box component={Link} to={Routes_path.COOKIES} sx={linkSx}>
								<Typography variant="body2">Cookie Policy</Typography>
							</Box>
						</Stack>

						<ColumnTitle>Certificazioni</ColumnTitle>
						<Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
							<VerifiedIcon fontSize="small" sx={{ color: "#ffd42d" }} />
							<Box
								component="a"
								href={certPdf}
								target="_blank"
								rel="noopener noreferrer"
								sx={{ ...linkSx, py: 0 }}
							>
								<Typography variant="body2">ISO 9001 (PDF)</Typography>
							</Box>
						</Stack>
					</Grid>
				</Grid>

				<Divider sx={{ my: 4, borderColor: "rgba(255,255,255,0.1)" }} />

				<Stack
					direction={{ xs: "column", sm: "row" }}
					spacing={1}
					sx={{
						justifyContent: "space-between",
						alignItems: { xs: "flex-start", sm: "center" },
					}}
				>
					<Typography variant="caption" sx={{ color: "rgba(255,255,255,0.5)" }}>
						© {new Date().getFullYear()} Scarso Romualdo e Figli S.p.A.
					</Typography>
					<Typography variant="caption" sx={{ color: "rgba(255,255,255,0.5)" }}>
						P.IVA 00227510286
					</Typography>
				</Stack>
			</Container>
		</Box>
	);
}
